import React, { memo, useMemo } from "react";
import { BlackButton } from "../../../../../Components/Buttons/BlackButton";
import { PurpleButton } from "../../../../../Components/Buttons/PurpleButton";
import { WhiteButton } from "../../../../../Components/Buttons/WhiteButton";
import PhotoReviewSection from "./components/PhotoReviewSection";
import PropertyDetailsForm from "./components/PropertyDetailsForm";

const MintPublishPage = memo(({
  images,
  removeElement,
  dragStartIdx,
  setDragStartIdx,
  dragEndIdx,
  setDragEndIdx,
  swapElements,
  metaDetails,
  setMetaDetails,
  addressInput,
  setAddressInput,
  addressDetails,
  checkInModal,
  setCheckInModal,
  checkOutModal,
  setCheckOutModal,
  onBack,
  onMint,
  mintJob,
  isMinting,
}) => {
  const currentStatus = useMemo(() => mintJob?.sync_status || null, [mintJob?.sync_status]);
  const isPending = useMemo(() => currentStatus === "pending", [currentStatus]);
  const isFailed = useMemo(() => currentStatus === "failed", [currentStatus]);

  const renderStatusText = useMemo(() => {
    if (isMinting || isPending) return "Minting...";
    if (currentStatus === "confirmed") return "Minted";
    if (isFailed) return "Retry Mint";
    return "Mint Apartment";
  }, [isMinting, isPending, currentStatus, isFailed]);

  return (
    <div className="flex flex-col w-full h-full">
      {/* Main Content */}
      <div className="flex-1 flex flex-col md:flex-row gap-4 md:gap-8 w-full px-4 md:px-8 py-4 md:py-6">
        {/* Left Side - Photo Review */}
        <div className="flex flex-col gap-4 w-full md:w-1/2 h-fit">
          <PhotoReviewSection
            images={images}
            removeElement={removeElement}
            dragStartIdx={dragStartIdx}
            setDragStartIdx={setDragStartIdx}
            dragEndIdx={dragEndIdx}
            setDragEndIdx={setDragEndIdx}
            swapElements={swapElements}
          />
          
          {/* Edit Photos Button */}
          <div className="w-full flex justify-end">
            <BlackButton onClick={onBack} text="Edit" />
          </div>
        </div>

        {/* Right Side - Property Details Form */}
        <div className="w-full md:w-1/2">
          <PropertyDetailsForm
            metaDetails={metaDetails}
            setMetaDetails={setMetaDetails}
            addressInput={addressInput}
            setAddressInput={setAddressInput}
            addressDetails={addressDetails}
            checkInModal={checkInModal}
            setCheckInModal={setCheckInModal}
            checkOutModal={checkOutModal}
            setCheckOutModal={setCheckOutModal}
          />
        </div>
      </div>

      {/* Navigation Buttons - Fixed at Bottom */}
      <div className="w-full flex flex-row gap-3 md:justify-between items-center px-4 md:px-8 py-3 md:py-6 bg-white border-t border-gray-200 shadow-lg">
        <WhiteButton  
          text="Back"
          onClick={onBack} 
          className="flex-1 md:w-[120px] h-[45px] md:h-[50px] flex items-center justify-center text-sm md:text-base font-medium"
        />
        <PurpleButton
          text={renderStatusText}
          onClick={onMint}
          disabled={isMinting || isPending}
          className="flex-1 md:w-[140px] h-[45px] md:h-[50px] flex items-center justify-center text-sm md:text-base font-medium"
        />
      </div>
    </div>
  );
});

MintPublishPage.displayName = "MintPublishPage";

export default MintPublishPage;
